<template>
<div id="orders">
  <b-container>
    <b-row>
      <b-col>
        <h3>Orders</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4">
        <!-- <h4>Filter</h4> -->
        <div class="filter-badges">
          <div class="one-badge" v-for="(product,index) in products">
            <b-badge @click="setFilterProduct(product.productTitle)" class="btn btn-sm" pill :variant="filteredProduct == product.productTitle ? 'primary' : ''">{{product.productTitle}}</b-badge>
            <!-- <b-button variant="info" style="">Button</b-button> -->
          </div>
        </div>
      </b-col>
      <b-col>
        <div class="export">
          <b-button @click="forest24" variant="info" style="">Last 24 Forest</b-button>
          <b-button variant="primary" style="">Export Visible</b-button>
          <b-button @click="testCheckout" variant="primary" style="">Test Checkout</b-button>
          <b-button @click="testOrder" variant="primary" style="">TestOrder</b-button>
        </div>
      </b-col>
    </b-row>

    <b-table hover :items="filteredOrders" :fields="fields">
      <template slot="actions" slot-scope="data">
        <span class="btn btn-sm" @click="downloadOrder(data.item.orderId)" style="color: blue;">
          <i class="fas fa-download" />
        </span>
        <!-- <span class="btn btn-sm" @click="startTask(data.item.taskId)" style="color: blue;">
          <i class="fas fa-play" />
        </span>-->
      </template>
      <!-- <template slot="name" slot-scope="data">
        {{data.value}} -->
      <!-- {{data.value.first}} {{data.value.last}} -->
      <!-- <template slot="FOOT_name" slot-scope="data"> -->
      <!-- A custom formatted footer cell  for field 'name' -->
      <!-- <strong>hello</strong> -->
      <!-- </template> -->
    </b-table>

  </b-container>
</div>
</template>
<script>
import { orderService } from '@/services/order'
import {checkoutService} from '@/services/checkout'
const exOrder = {
  "email": "hi@graffixed.com",
  "productTitle": "Atmos X Kaws",
  "price": 45.99,
  name: "John Doe",
  "status": "pending",
  "success": false,
}
let exOrders = []
for (let i = 0; i < 50; i++) {
  exOrders.push(exOrder)
}
export default {
  name: 'OrderTable',
  created() {
    this.$store.dispatch('orders/getOrders')
    //doing in it in home.vue too
  },
  data() {
    return {
      filteredProduct: '',
      myVariant: 'primary',
      exOrders,
      fields: [
        'email',
        {
          key: 'productTitle',
          label: 'Product'
        },
        'price',
        'status',
        'actions'
      ]
    }
  },
  methods: {
    async forest24() {
      console.log('exporting last 24 hours of orders to forest admin')
      
    },
    async testOrder() {
      try {
      let order = await orderService.createTestOrder()
      console.log(`testOrder order $${order.orderId} created!`)
      this.$store.dispatch('orders/getOrders')
    } catch(e) {
      console.error(e)
    }
  },
    async testCheckout() {
      try {
      let order = await checkoutService.testCheckout()
      console.log(`testCheckout order $${order.orderId} created!`)
      this.$store.dispatch('orders/getOrders')
    } catch(e) {
      console.error(e)
    }
  },
    setFilterProduct(title) {
      // console.log(`setting filtered product to ${title}`)
      if (this.filteredProduct == title) {
        return this.filteredProduct = ''
      }
      this.filteredProduct = title
    },
    addOrder() {
      this.taskIndex += 1
      let task = { id: this.taskIndex }
      this.$store.commit('addTask', task)
    },
    editOrder(id) {
      console.log('editTask called with taskId', id)
    },
    startTask(taskId) {
      console.log('startTask called', taskId)
    },
    rmTask(taskId) {
      console.log('rmTask called', taskId)
    },
    stopTask(taskId) {
      console.log('stopTask called', taskId)
    },
    pauseTask(taskId) {
      console.log('pauseTask called', taskId)
    },
    removeAll() {
      console.log('removeAll called')
    },
    stopAll() {
      console.log('stopAll called')
    },
    startAll() {
      console.log('startAll called')
    },
    async downloadOrder(orderId) {
      console.log(`downloading order ${orderId}`)
      let acoData = await orderService.downloadACO(orderId)
      console.log(`got acoData for order ${orderId}`)
      console.log(acoData)
    }
  },
  computed: {
    filteredOrders() {
      if (!this.filteredProduct) return this.orders
      let filtered = this.orders.filter(p => p.productTitle == this.filteredProduct)
      return filtered
    },
    products() {
      return this.$store.state.products.products
    },
    orders() {
      return this.$store.state.orders.orders
    }
  },
}
</script>

<style scoped lang="stylus">
.round-btn {
  border-radius: 100px;
}
.one-badge
  margin: 2px;
.filter-badges
  display: flex;
  justify-content: center

#toppy
  display: flex;
  justify-content: center
  // margin: 5px;

.export
  display: flex
  justify-content: flex-end;
  margin-bottom: 10px;
  // margin: auto
#orders
  // padding 30px
</style>
